import { useTranslation } from 'react-i18next';
import { useContentSuggestions, useProfilePathways } from '../../../hooks';
import React, { useEffect, useState } from 'react';
import {
  CredentialSearchbar,
  NoItemView,
  PathwaysBox,
} from '../../../components';
import './PathwaysViewContent.css';
import { inIframe } from '../../../utils';
import { Link, NavLink } from 'react-router-dom';
import { useDebounce } from '../../../hooks/useDebounce';
import { useProfilePathwaysTabs } from '../../../hooks/useProfilePathwaysTabs';

interface PathwaysViewContentProps {
  username: string;
  tab?: string;
}

export const PathwaysViewContent: React.FC<PathwaysViewContentProps> = ({
  username,
  tab = '',
}) => {
  const { t } = useTranslation('library');
  const { pathways, pathwaysLoaded } = useProfilePathwaysTabs({username, tab})
  const DEFAULT_TAB = '';
  const ASSIGNMENT_TAB = 'assigned';
  const ENROLLED_TAB = 'enrolled';
  const [filteredPathways, setFilteredPathways] = useState<any[]>([]);
  const [pathwaySearchTerm, setPathwaySearchTerm] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');

  useEffect(() => {
    setPathwaySearchTerm('');
    switch(tab){
      case ASSIGNMENT_TAB:
        setErrorMsg(inIframe()
        ? `${username} ${t(
            "hasn't been assigned to a pathway yet."
          )}`
        : `You haven't been assigned to a pathway yet.`)
        break
      case ENROLLED_TAB:
        setErrorMsg(inIframe()
        ? `${username} ${t(
            "hasn't enrolled in any pathways yet."
          )}`
        : `You haven't enrolled in any pathways yet.`)
        break
      default:
        setErrorMsg(`${username} ${t(
                      "hasn't created any pathways yet."
                    )}`)
    }
  }, [tab])
  

  useEffect(() => {
    setFilteredPathways(pathways || []);
  }, [pathwaysLoaded, pathways, tab]);

  useDebounce(
    () => {
      if (pathwaySearchTerm.length > 2) {
        setFilteredPathways(
          pathways.filter((pathway) =>
            String(pathway?.name)
              .toUpperCase()
              .includes(String(pathwaySearchTerm).toUpperCase())
          )
        );
      } else {
        setFilteredPathways(pathways);
      }
    },
    200,
    [pathwaySearchTerm]
  );

  return (
    <span>
      <div
        className="ov_panel active with-custom-tab"
        data-name="p"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont" style={{ padding: '0px' }}>
          <div className="div-block-421" style={{ marginBottom: '20px' }}>
            <div className="profile_menu">
              <Link
                to={'/profile/pathways'}
                className={`prof_menu first ${
                  tab === DEFAULT_TAB ? 'active' : ''
                }`}
              >
                {t('My pathways')}
              </Link>
              <Link
                to={'/profile/pathways/assigned'}
                className={`prof_menu first ${
                  tab === ASSIGNMENT_TAB ? 'active' : ''
                }`}
              >
                {t('Assigned pathways')}
              </Link>
              <Link
                to={'/profile/pathways/enrolled'}
                className={`prof_menu first ${
                  tab === ENROLLED_TAB ? 'active' : ''
                }`}
              >
                {t('Enrolled pathways')}
              </Link>
            </div>
          </div>

          {
            <div className="br_row">
              <div
                className="form-block-15 w-form"
                style={{ marginBottom: '15px' }}
              >
                <CredentialSearchbar
                  searchTerm={pathwaySearchTerm}
                  setSearchTerm={setPathwaySearchTerm}
                ></CredentialSearchbar>
              </div>
              <PathwaysBox
                userPathways={filteredPathways}
                userPathwaysLoaded={pathwaysLoaded}
                username={username}
                showProgressBar={true}
                isAssignedPathway={tab!==DEFAULT_TAB}
              ></PathwaysBox>

              {pathways?.length === 0 &&
                pathwaysLoaded &&
                inIframe() && (
                  <NoItemView
                    displayMessage={errorMsg}
                    imageUrl={'/images/tools.png'}
                    displayPadding={true}
                  />
                )}
            </div>
          }
        </div>
      </div>
    </span>
  );
};
